
  import { AccountModule, AccountStore } from '@/store/account';
  import { Options, Vue } from 'vue-class-component';
  import { NavigationModule, NavigationStore } from '@/store/navigation';
  import RegisterSmallLight from '@/components/RegisterSmallLight.vue';

  @Options({
    components: {
      RegisterSmallLight
    }
  })
  export default class RegisterSmallLightComponent extends Vue {
    private accountStore: AccountModule = AccountStore;
    private navigationStore: NavigationModule = NavigationStore;

    mounted() {
      this.accountStore.initAuthDataFromLocalStorage();
    }
  }
